import { useState } from 'react';

import { useT } from '../../i18n';
import { Dialog } from '../../ui/Dialog';
import styles from './Sheets.module.css';

/**
 * Fragt das Passwort einer Prüfung ab — vor dem Herunterladen und vor dem Löschen (Vorgabe des
 * Nutzers, 2026-10-09). Was „stimmt“ heisst, entscheidet der Aufrufer: bei Classic der
 * Klartext der Liste, bei Relay der Server, beim Löschen die Ablageform auf dem Gerät.
 *
 * Wie beim Einstellungsschloss (`SperrDialog.tsx`): kein Zählwerk, keine Sperrzeit, und ein
 * falscher Versuch leert das Feld.
 */
export function PruefungsPasswortDialog({
  pruefung,
  zweck,
  pruefe,
  onClose,
}: {
  pruefung: string;
  zweck: 'laden' | 'loeschen';
  /** `true`: stimmt, der Dialog ist erledigt. `false`: falsch, noch einmal. */
  pruefe: (eingabe: string) => Promise<boolean>;
  onClose: () => void;
}) {
  const t = useT();
  const [eingabe, setEingabe] = useState('');
  const [falsch, setFalsch] = useState(false);
  const [laeuft, setLaeuft] = useState(false);

  const versuchen = async () => {
    if (laeuft) return;
    setLaeuft(true);
    try {
      if (await pruefe(eingabe)) return;
      setEingabe('');
      setFalsch(true);
    } finally {
      setLaeuft(false);
    }
  };

  return (
    <Dialog kicker={t.pruefungsPasswort.kicker} title={pruefung} onClose={onClose} width={420}>
      <div className={`sc ${styles.sperrBody}`}>
        <div className={styles.textNote}>{t.pruefungsPasswort.hint}</div>
        <label className={styles.textRow}>
          <span className={styles.textLabel}>{t.pruefungsPasswort.password}</span>
          <input
            className={styles.textInput}
            type="password"
            value={eingabe}
            autoFocus
            autoCapitalize="off"
            autoCorrect="off"
            onChange={(e) => {
              setEingabe(e.target.value);
              setFalsch(false);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') void versuchen();
            }}
          />
        </label>
        {falsch && <div className={styles.sperrFalsch}>{t.pruefungsPasswort.wrong}</div>}
        <div className={styles.serverActions}>
          <button type="button" className={`tap ${styles.stufe}`} disabled={laeuft} onClick={() => void versuchen()}>
            {zweck === 'laden' ? t.pruefungsPasswort.laden : t.pruefungsPasswort.loeschen}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
